module.exports = __webpack_public_path__ + "img/_calendar_small.bef35bf6.svg";